// TODO: Fix the types to match the backend API
enum UploadType {
  INSTRUCTION = '/instructions',
  QA = '/qa',
  BLUEPRINT = '/blueprint',
  ASSET_PHOTO = 'asset_photos',
  POWER_SUPPLY_DOCUMENT = 'power_supply_document'
}
export default UploadType
